/***************************************************************************************************
 * Load `$localize` onto the global scope - used if i18n tags appear in Angular templates.
 */
import '@angular/localize/init';
import 'core-js';
import 'jspdf-autotable';
import 'zone.js';

(window || ({} as any)).nameOf = <T, Y>(key: keyof T, innerKey: keyof Y) =>
    innerKey ? `${key as string}.${innerKey as string}` : key;

(window || ({} as any)).ciFindByKey = <T>(dict: Record<keyof T, any>, key: string) => {
    return Object.keys(dict)
        .filter((k) => k.toUpperCase() === key.toUpperCase())
        .map((k) => dict[k])
        .slice(-1)
        .pop();
};
